import { Form } from "antd";
import { HeaderOverview, IRenderLineChart, RenderLineChart } from "components";
import { useAppLanguage } from "providers/app-language";
import { useOverview } from "providers/overview";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import tw from "twin.macro";
import { useGetPropertyDashboardActivitiesTime } from "service/dashboard/property/activities";
import { ErrorDashboard, LoadingDashboard, NoDataDashboard } from "../..";
import { IData } from "service/dashboard/interface";

const WrapperList = styled.div`
  ${tw`bg-white h-full rounded-app p-4`}
`;

const ActivitiesTime = () => {
  const { t } = useTranslation();
  const { findDate } = useOverview();
  const { formatDate } = useAppLanguage();

  const activitiesDate = Form.useWatch("activitiesDate");
  const date = findDate(activitiesDate, "year");

  const { data, isFetching, isError, error } =
    useGetPropertyDashboardActivitiesTime({
      ...date,
    });

  if (isFetching) {
    return (
      <WrapperList>
        <LoadingDashboard loading={isFetching}>
          <HeaderOverview
            title={t("activities-times/year")}
            name="activitiesDate"
            formatDate="year"
          />
          <div className="h-[230px]"></div>
        </LoadingDashboard>
      </WrapperList>
    );
  }

  const getData: IData[] =
    data?.map((e) => {
      const month = formatDate({ date: e.month, format: "month" });
      return { name: month, count: e?.count || 0 };
    }) || [];

  const dataLine: IRenderLineChart = {
    data: getData,
    dataKeyX: "name",
    dataKeyY: "count",
    height: 230,
  };

  return (
    <WrapperList>
      <HeaderOverview
        title={t("activities-times/year")}
        name="activitiesDate"
        formatDate="year"
      />
      {isError ? (
        <ErrorDashboard error={error} height="230px" />
      ) : !data || data.length <= 0 ? (
        <NoDataDashboard height="230px" />
      ) : (
        <RenderLineChart {...dataLine} />
      )}
    </WrapperList>
  );
};

export default ActivitiesTime;
